import { useUiStore } from "../store/uiStore";

export interface DisplayOption {
  id: string;
  label: string;
  useValue: () => boolean;
  setValue: (value: boolean) => void;
}

export const DISPLAY_OPTIONS: readonly DisplayOption[] = [
  {
    id: "highlight-jspace-last-3",
    label: "Highlight J-Space Last 3 Digits",
    useValue: () => useUiStore((s) => s.highlightJSpaceLastThree),
    setValue: (value) =>
      useUiStore.getState().setHighlightJSpaceLastThree(value),
  },
];
